var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconDecrease = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-719.285 -502.751)" },
                React.createElement("g", { transform: "translate(8.317 -8.5)" },
                    React.createElement("path", { d: "M715.8,536.6l4.5-4.5l3.5-3.5" }),
                    React.createElement("path", { d: "M715.8,528.6h8v8" })),
                React.createElement("g", { transform: "translate(731.166 504.284)" },
                    React.createElement("path", { d: "M13.3,3.1L8.8,7.6l-3.5,3.5" }),
                    React.createElement("path", { d: "M13.3,11.1h-8v-8" }))))));
});
export default IconDecrease;
//# sourceMappingURL=IconDecrease.js.map